<template>
 <div id="chart1"></div>
</template>
<script>
export default{
    mounted(){

      var options = {
        series: [76],
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true,
            color:'#fff'
          }
        },
        colors: ['	#008080'],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#fff',
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: -2,
                fontSize: '22px'
              }
            }
          }
        },
        grid: {
          padding: {
            top: -10
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          },
        },

      };

      var chart = new ApexCharts(document.querySelector("#chart1"), options);
      chart.render();
    }
}

</script>